export const validatePassword = password => password.length >= 6

export const doPasswordsMatch = (password, confirmation) => typeof password === 'string' &&
         typeof confirmation === 'string' &&
         password === confirmation

export const isValidEmail = email => (
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)
)



// WEBPACK FOOTER //
// ./src/services/password-validation.js